import { useTheme } from "../context/ThemeContext";

/**
 * WhoWeAre — editorial statement scene. One eyebrow, one headline,
 * an outcome number strip, a single quiet supporting line. The three
 * pill actions (Global presence / Customers / Companies) are rendered
 * by CenterPanel just below the composition.
 */
const SlideWhoWeAre = () => {
  const { isDark } = useTheme();

  const outcomes = [
    { value: "2016", label: "Founded in Singapore" },
    { value: "50+", label: "Aeroplay staff globally" },
    { value: "500+", label: "Group staff worldwide" },
    { value: "40+", label: "Airlines served" },
  ];

  return (
    <div>
      <div className="k-eyebrow" style={{ color: "var(--k-accent)" }}>Who we are</div>
      <h2 className={`k-h2 mt-3 max-w-[38ch] ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
        Aeroplay Entertainment.
        <span className="block whitespace-nowrap" style={{ color: "var(--k-accent)" }}>Fast. Lean. Personal. Intelligent.</span>
      </h2>
      <p className={`k-lead mt-6 max-w-[86ch] ${isDark ? "text-white/70" : "text-black/60"}`}>
        An independent Content Service Provider inside a media ecosystem —
        digital workflows from studio to seat, with an obsessive focus on
        speed, cost and personalisation.
      </p>

      <dl className={`mt-12 pt-8 grid grid-cols-4 gap-8 border-t ${isDark ? "border-white/10" : "border-black/10"}`}>
        {outcomes.map((o) => (
          <div key={o.value}>
            <dd className={`text-[40px] font-semibold tracking-tight leading-none ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
              {o.value}
            </dd>
            <dt className={`mt-2 text-[13px] ${isDark ? "text-white/55" : "text-black/55"}`}>{o.label}</dt>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default SlideWhoWeAre;
